import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    info: (request) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'nav/info',
                    method: 'POST',
                    body: request,
                    types: [
                        types.LOAD_NAVIGATION_INFO_REQUEST,
                        types.LOAD_NAVIGATION_INFO_SUCCESS,
                        types.LOAD_NAVIGATION_INFO_FAILURE
                    ]
                }
            });
        }
    },
    loadTasksMenu: (request) => {
        return (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'nav/tasks-menu',
                    method: 'POST',
                    body: request,
                    types: [
                        types.LOAD_TASKS_MENU_REQUEST,
                        types.LOAD_TASKS_MENU_SUCCESS,
                        types.LOAD_TASKS_MENU_FAILURE
                    ]
                }
            });
        }
    },

    setSubscriptionLogo: (logo) => {
        return (dispatch) => {
            return dispatch({
                type: types.SET_NAV_SUBSCRIPTION_LOGO,
                payload: {
                    logo: logo
                }
            })
        }
    },
}
